var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#00D2B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 8a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4h24zm-24 2a2 2 0 0 0-1.994 1.85L10 12v24a2 2 0 0 0 1.85 1.994L12 38h24a2 2 0 0 0 1.994-1.85L38 36V12a2 2 0 0 0-1.85-1.994L36 10H12zm21 19a1 1 0 0 1 .116 1.993L33 31H15a1 1 0 0 1-.116-1.993L15 29h18zm0-6a1 1 0 0 1 .116 1.993L33 25H15a1 1 0 0 1-.116-1.993L15 23h18zm0-6a1 1 0 0 1 .116 1.993L33 19H15a1 1 0 0 1-.116-1.993L15 17h18z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.157951c71002d7fc99082cebb7a3b783.svg";
export { ForwardRef as ReactComponent };